import { useEffect } from "react";
import type { RadioGroupInterface } from "interfaces";

export const RadioGroup: React.FC<RadioGroupInterface> = ({
  assistiveText,
  name,
  legend,
  legendClass,
  formItemClass,
  errorMessage,
  radios,
  register,
  registerOptions,
  unregister
}) => {
  useEffect(() => {
    return () => {
      if (unregister) {
        unregister(name)
      }
    }
  }, []);
  return (
    <div className={`wc-form-item${formItemClass ? " " + formItemClass : ""}`}>
      <fieldset className="wc-fieldset">
        <legend className={`wc-fieldset__legend${legendClass ? " " + legendClass : ""}`}>{legend ?? ""}</legend>
        {assistiveText && <span className="wc-assist">{assistiveText}</span>}
        {errorMessage && (
          <span style={{ marginLeft: 5 }} className="field-validation-error wc-assist wc-assist--error" role="alert">
            {errorMessage}
          </span>
        )}
        {radios &&
          radios.map(({ value, valueText, subText }) => (
            <label className="wc-radio" key={value}>
              <input
                {...register(name, registerOptions)}
                type="radio"
                value={value}
                id={`field-${value}`}
              />
              {
                subText ? (
                  <span className="flex flex-col">
                    <p className="h6 mb-0">{valueText || value}</p>
                    <p>{subText}</p>
                  </span>
                ) : (<span><p className="h6">{valueText || value}</p></span>)
              }
            </label>
          ))}
      </fieldset>
    </div>
  );
};

export default RadioGroup;
